module.exports = __webpack_public_path__ + "media/images/enel-f0d2dcd7e6be037e4fbef51ff0b4b6cc.png";